export default [
    {
        path: '/modulo/index',
        name: 'ModuloView',
        component: () => import('../views/seguridad/ModuloView.vue')
    },
    {
        path: '/opcion/index',
        name: 'OpcionView',
        component: () => import('../views/seguridad/OpcionView.vue')
    },
    {
        path: '/usuario/index',
        name: 'UsuarioView',
        component: () => import('../views/seguridad/UsuarioView.vue')
    },
    {
        path: '/perfil-modulo-opcion/index',
        name: 'PerfilModuloOpcionView',
        component: () => import('../views/seguridad/PerfilModuloOpcionView.vue')
    },
    {
        path: '/informacion/usuario',
        name: 'InformacionUsuarioView',
        component: () => import('../views/seguridad/InformacionUsuarioView.vue')
    },
]